<template>
  <div>
    <h3 class="title mb-3">
      {{ $t("page-unit-ical-sync.section-sawdays-to-other-channels.title") }}
    </h3>
    <p>{{ $t("page-unit-ical-sync.section-sawdays-to-other-channels.intro") }}</p>
    <p><b>{{ iCalLink }}</b> <v-icon class="copy" v-if="canCopy" @click="copy(iCalLink)">mdi-text-box-multiple</v-icon></p>
    <v-divider class="my-6"></v-divider>

    <h3 class="title mb-3">
      {{ $t("page-unit-ical-sync.section-other-channels-to-sawdays.title") }}
    </h3>
    <p>{{ $t("page-unit-ical-sync.section-other-channels-to-sawdays.intro") }}</p>
    <v-form ref="form" v-model="formValid">
        <v-row>
            <v-col>
                <v-autocomplete
                    :items="channelItems"
                    :label="$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.channel.label')"
                    :placeholder="$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.channel.placeholder')"
                    item-value="key"
                    outlined
                    dense
                    v-model="channel"
                    :rules="channelRules"
                ></v-autocomplete>
            </v-col>
            <v-col cols=7>
                <v-text-field
                    :label="$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.feed.label')"
                    :placeholder="$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.feed.placeholder')"
                    outlined
                    dense
                    v-model="url"
                    :rules="urlRules"
                ></v-text-field>
            </v-col>
            <v-col cols=2>
                <v-btn color="warning lighten-1" dark @click.stop="addFeed()" :loading="addingFeed">
                <v-icon left small>mdi-plus</v-icon>{{ $t('global-terms.add') }}
                </v-btn>
            </v-col>
        </v-row>
    </v-form>
    <synced-channels-table :calendarFeeds="calendarFeedsByIds(this.unit.calendarFeeds)" :channels="this.externalBookingChannels" :unit="unit" />
    <h3 class="title mb-3">
      {{ $t("page-unit-ical-sync.section-how-to-sync.title") }}
    </h3>
    <p>{{ $t("page-unit-ical-sync.section-how-to-sync.intro") }}</p>
  </div>
</template>
<script>
import { mapActions, mapState } from 'pinia'
import SyncedChannelsTable from './SyncedChannelsTable'
import { forEachObjIndexed, clone } from 'ramda'
import { useUserStore, useUnitCalendarFeedStore, useBookingChannelStore } from '@/stores'

export default {
  name: 'manage-ical-sync-tab',
  data () {
    return {
      canCopy: false,
      formValid: false,
      addingFeed: false,
      channel: null,
      url: null,
      channelRules: [
        v => !!v || this.$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.channel.validation-required'),
      ],
      urlRules: [
        v => !!v || this.$t('page-unit-ical-sync.section-other-channels-to-sawdays.fields.feed.validation-required'),
      ],
    }
  },
  props: {
    unit: {
      type: Object,
      required: true,
    },
    place: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useBookingChannelStore, {
      externalBookingChannels: 'findAllExternal',
    }),
    ...mapState(useUserStore, ['currentUserHasRole']),
    ...mapState(useUnitCalendarFeedStore, {
      calendarFeedsByIds: 'findByIds',
    }),
    iCalLink () {
      return `${process.env.VUE_APP_INTEGRATION_BRIDGE_HOST}/ical/${this.unit.id}/feed.ics`
    },
    channelItems () {
      let channels = []
      forEachObjIndexed((value, key) => {
        channels.push({
          key: key,
          text: value.name,
        })
      })(this.externalBookingChannels)

      return channels
    },
  },
  methods: {
    clone,
    ...mapActions(useUnitCalendarFeedStore, ['httpCreateUnitCalendarFeed']),
    ...mapActions(useBookingChannelStore, ['httpGetBookingChannels']),
    async copy (text) {
      await navigator.clipboard.writeText(text)
    },
    addFeed () {
      if (this.$refs.form.validate()) {
        this.addingFeed = true

        let calendarFeed = {
          unit: this.unit,
          channel: this.externalBookingChannels[this.channel],
          url: this.url.trim(),
        }

        let cloneUnit = this.clone(this.unit)
        this.httpCreateUnitCalendarFeed({ calendarFeed, unit: cloneUnit })
          .then(() => {
            this.$refs.form.reset()
            this.addingFeed = false
          })
          .catch(() => {
            this.addingFeed = false
          })
      }
    },
  },
  created () {
    // copy won't work on development as it requires https, however we can still show the button
    this.canCopy = process.env.NODE_ENV === 'development' || !!navigator.clipboard

    this.httpGetBookingChannels()
  },
  components: {
    SyncedChannelsTable,
  },
}
</script>
<style lang="scss" scoped>
    .copy {
        cursor: pointer;
        margin-left:20px;
    }
    p {
      white-space: pre-wrap;
    }
</style>
